import React, { useMemo } from "react";

// Navigation
import { useNavigate } from "react-router-dom";

// components
import Button from "components/UiKit/Button";
import CountUpOnScroll from "components/CountUpOnScroll";

// Lib
import { sanitize } from "dompurify";
import { shallowEqual } from "react-redux";
import { filteredData } from "lib/libraries";

// Actions
import { useAppSelector } from "lib/hooks/useDispatch";

// Animation
import { Fade } from "react-awesome-reveal";

// Constants
import { buildingFuture } from "constans/landing";
import { initialStateFormat } from "constans/request-form";

// Type
import { BuildingFutureType, FDADrugCountProps } from "../type";

// Default data
const defaultDataFDADrugCount: FDADrugCountProps = {
  name: "",
  type: 0,
  catNumber: "",
  description: "",
  compoundsCount: 0,
  compoundsListId: 0,
  descriptionGen: ""
};

export const BuildFuture: React.FC = () => {
  const navigate = useNavigate();
  const defaultStringFind: string = "FDA Approved Drugs";

  const {data} = useAppSelector(
    (store) => {
      return {
        data: store.libraries.data
      }
    },
    shallowEqual
  );

  const drugRepurposingData: FDADrugCountProps[] = useMemo(
    () => filteredData(data || [], 2, false),
    [data]
  );

  const handlerClick = () => {
    localStorage.setItem("format", JSON.stringify(initialStateFormat));
    navigate("/request-form");
  };

  const FDADrugCount: FDADrugCountProps = drugRepurposingData.length
    ? drugRepurposingData.find((x) => x?.name?.includes(defaultStringFind)) as FDADrugCountProps
    : defaultDataFDADrugCount;

  return (
    <div className="section-build-future">
      <div className="wrapper">
        <div className="section-build-future__content">
          <Fade triggerOnce direction="up">
            <h4 className="section-build-future__title">
              Fresh view. Innovative approach. Cutting edge biochemicals.
            </h4>
          </Fade>
          <Fade triggerOnce direction="up">
            <p className="section-build-future__text">
              Enamine is a renowned leader in the market of building blocks.
            </p>
          </Fade>
          <div className="section-build-future__carts flex flex-ai-start flex-jc-center flex-direction-column-desktop">
            {buildingFuture(FDADrugCount?.compoundsCount || 0)
              .map((x: BuildingFutureType, i: number) => {
                return (
                  <div
                    key={x.text || "" + i}
                    className="section-build-future__cart"
                  >
                    <CountUpOnScroll
                      duration={1}
                      endValue={x.count || 0}
                      className="section-build-future__cart-count"
                    />
                    <p className="section-build-future__cart-text"
                       dangerouslySetInnerHTML={{ __html: sanitize(x.text || "") }} />
                  </div>
                );
              })}
          </div>

          <p className="section-build-future__text-btn text-align-cn mb20">
            Send a request to create your collection of bioactive compounds. Once submitted, our team will<br /> review
            and process your request promptly. Thank you for choosing our services.
          </p>

          <div className="flex-jc-center display-none-mobile">
            <Button
              type="button"
              color="green"
              variable="info-big"
              onPress={handlerClick}
              label="Create Collection"
            />
          </div>

          <div className="flex-jc-center display-flex-mobile">
            <Button
              type="button"
              color="green"
              variable="info-big"
              label="Send a request"
              onPress={handlerClick}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuildFuture;
